/* ============================================
   Mersambalaj prototype — main.js
   Vanilla. window.Mers namespace.
   ============================================ */

window.Mers = window.Mers || {};

(() => {
  'use strict';

  // ---- Sticky header shrink on scroll ----
  const header = document.querySelector('[data-section="header"]');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---- Collection: ?kategori= → hero başlık/breadcrumb (Shopify port'ta collection.title) ----
  const kategori = new URLSearchParams(location.search).get('kategori');
  const collTitle = document.querySelector('.collection-hero__title');
  if (kategori && collTitle) {
    const KAT = {
      'koli': 'Koliler',
      'tek-oluklu': 'Tek Oluklu Koliler',
      'cift-oluklu': 'Çift Oluklu Koliler',
      'triplex': 'Triplex Koliler',
      'tasinma-seti': 'Taşınma Koli Setleri',
      'palet': 'Palet Kolileri',
      'kargo': 'Kargo Kutuları',
      'e-ticaret': 'E-Ticaret Kutuları',
      'bantli': 'Bantlı Kargo ve E-Ticaret Kutuları',
      'arsiv': 'Arşiv Kutuları',
      'lojistik': 'Lojistik Depolama Kutuları',
      'resim-cerceve': 'Resim Çerçeve Kutuları',
      'yas-meyve': 'Yaş Meyve Kutuları',
      'gida': 'Gıda Ambalajları',
      'kraft-sapli-canta': 'Kraft Kağıt Saplı Çantalar',
      'kraft-sapsiz-canta': 'Kraft Kağıt Sapsız Çantalar',
      'karton-canta': 'Karton Çantalar',
      'koli-bantlari': 'Koli Bantları',
      'cift-tarafli-bantlar': 'Çift Taraflı Bantlar',
      'kagit-bantlar': 'Kağıt Bantlar',
      'strechler': 'Strechler',
    };
    const name = KAT[kategori];
    if (name) {
      const sp = name.lastIndexOf(' ');
      const head = sp > 0 ? name.slice(0, sp) : '';
      const tail = sp > 0 ? name.slice(sp + 1) : name;
      collTitle.innerHTML = (head ? head + ' ' : '') +
        '<span class="collection-hero__title-accent">' + tail + '</span>';
      const crumb = document.querySelector('.collection-hero__breadcrumb .is-current');
      if (crumb) crumb.textContent = name;
      document.title = name + ' — Mers Packaging';
    }
  }

  // ---- Scroll reveal via IntersectionObserver ----
  const revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -80px 0px' });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  // ---- Hero slider (carousel) ----
  const slider = document.querySelector('[data-hero-slider]');
  if (slider) {
    const sliderTrack = slider.querySelector('[data-slider-track]');
    const slides = Array.from(slider.querySelectorAll('.hero-slide'));
    const dotsWrap = slider.querySelector('[data-slider-dots]');
    const prevBtn = slider.querySelector('[data-slider-prev]');
    const nextBtn = slider.querySelector('[data-slider-next]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const AUTOPLAY_MS = 7000;
    let current = 0;
    let timer = null;

    if (slides.length > 1) {
      // build dots
      const dots = slides.map((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'hero-slider__dot' + (i === 0 ? ' is-active' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', (i + 1) + '. slayt');
        dot.addEventListener('click', () => { goTo(i); restart(); });
        dotsWrap && dotsWrap.appendChild(dot);
        return dot;
      });

      const goTo = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
      };

      const start = () => {
        if (reduceMotion) return;
        if (timer) clearInterval(timer); // guard: never stack overlapping timers
        timer = window.setInterval(() => goTo(current + 1), AUTOPLAY_MS);
      };
      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      const restart = () => { stop(); start(); };

      prevBtn && prevBtn.addEventListener('click', () => { goTo(current - 1); restart(); });
      nextBtn && nextBtn.addEventListener('click', () => { goTo(current + 1); restart(); });

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', () => {
        document.hidden ? stop() : restart();
      });

      // basic swipe support
      let startX = null;
      slider.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { goTo(current + (dx < 0 ? 1 : -1)); restart(); }
        startX = null;
      }, { passive: true });

      goTo(0);
      start();
    }
  }

  // ---- Trust strip — duplicate items INSIDE the track for seamless single-row marquee ----
  const track = document.querySelector('[data-marquee]');
  if (track) {
    const items = Array.from(track.children);
    items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  // ---- Size search → builds collection URL with query params ----
  const sizeForm = document.querySelector('[data-size-search]');
  if (sizeForm) {
    sizeForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const en = sizeForm.querySelector('[name="en"]').value.trim();
      const boy = sizeForm.querySelector('[name="boy"]').value.trim();
      const yuk = sizeForm.querySelector('[name="yukseklik"]').value.trim();
      const params = new URLSearchParams();
      if (en) params.set('en', en);
      if (boy) params.set('boy', boy);
      if (yuk) params.set('yukseklik', yuk);
      const qs = params.toString();
      const url = qs ? `pages/collection.html?${qs}` : 'pages/collection.html';
      window.location.href = url;
    });
  }

  // ---- Featured products filter (visual only — Shopify will handle live) ----
  const filters = document.querySelectorAll('[data-filter]');
  filters.forEach((btn) => {
    btn.addEventListener('click', () => {
      filters.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  // ---- Sepete ekleme cart.js tarafından yönetilir (gerçek /cart/add.js) ----
  // Not: Eski prototip "placeholder" handler'ı kaldırıldı; sayacı sahteden
  // artırıp gerçek eklemeyi (cart.js) gölgeliyordu. Artık tek kaynak cart.js.

  // ---- Featured products carousel (filters + arrows + drag) ----
  const featTrack = document.querySelector('[data-featured-track]');
  if (featTrack) {
    const prevBtn = document.querySelector('[data-featured-prev]');
    const nextBtn = document.querySelector('[data-featured-next]');
    const filters = document.querySelectorAll('.featured__filter');
    const cards = Array.from(featTrack.querySelectorAll('.product-card'));

    const scrollByAmount = () => Math.max(260, featTrack.clientWidth * 0.8);

    const updateArrows = () => {
      const maxScroll = featTrack.scrollWidth - featTrack.clientWidth - 2;
      if (prevBtn) prevBtn.disabled = featTrack.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = featTrack.scrollLeft >= maxScroll;
    };

    prevBtn && prevBtn.addEventListener('click', () => featTrack.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' }));
    nextBtn && nextBtn.addEventListener('click', () => featTrack.scrollBy({ left: scrollByAmount(), behavior: 'smooth' }));
    featTrack.addEventListener('scroll', updateArrows, { passive: true });

    // filter tabs
    filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        filters.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const cat = btn.dataset.filter;
        cards.forEach((card) => {
          const show = cat === 'all' || card.dataset.cat === cat;
          card.classList.toggle('is-hidden', !show);
        });
        featTrack.scrollTo({ left: 0, behavior: 'smooth' });
        requestAnimationFrame(updateArrows);
      });
    });

    // drag to scroll (mouse / pointer)
    let isDown = false, startX = 0, startScroll = 0, moved = 0;
    featTrack.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return; // touch uses native scroll
      isDown = true; moved = 0;
      startX = e.clientX;
      startScroll = featTrack.scrollLeft;
      // NOT: capture burada ALINMAZ — hemen alınırsa click olayı track'e
      // yönlenir ve karttaki linkler mouse ile hiç tıklanamaz olur.
    });
    featTrack.addEventListener('pointermove', (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4 && !featTrack.classList.contains('is-dragging')) {
        featTrack.classList.add('is-dragging');
        try { featTrack.setPointerCapture(e.pointerId); } catch (_) {} // sadece gerçek sürüklemede
      }
      moved = Math.abs(dx);
      featTrack.scrollLeft = startScroll - dx;
    });
    const endDrag = () => {
      if (!isDown) return;
      isDown = false;
      setTimeout(() => featTrack.classList.remove('is-dragging'), 0);
    };
    featTrack.addEventListener('pointerup', endDrag);
    featTrack.addEventListener('pointercancel', endDrag);
    featTrack.addEventListener('mouseleave', endDrag);

    updateArrows();
  }

  // ---- Welcome offer popup (once per session) ----
  const popup = document.querySelector('[data-welcome-popup]');
  if (popup) {
    const STORAGE_KEY = 'mers_welcome_seen';
    let seen = false;
    try { seen = sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (_) {}

    const openPopup = () => {
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
    };
    const closePopup = () => {
      popup.hidden = true;
      document.body.style.overflow = '';
    };

    if (!seen) {
      window.setTimeout(openPopup, 1500);
    }

    popup.addEventListener('click', (e) => {
      if (e.target.closest('[data-popup-close]')) closePopup();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !popup.hidden) closePopup();
    });

    const popupForm = popup.querySelector('[data-popup-form]');
    const popupSuccess = popup.querySelector('[data-popup-success]');
    if (popupForm) {
      popupForm.addEventListener('submit', (e) => {
        e.preventDefault();
        popupForm.hidden = true;
        if (popupSuccess) popupSuccess.hidden = false;
        window.setTimeout(closePopup, 2200);
      });
    }
  }

  // ---- Quantity input handlers (+/-) with live total ----
  // Para birimi karari (2026-07): TL sonda — "248,00TL"
  const formatTRY = (n) =>
    n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';

  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('.qty__input');
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    const max = parseInt(input.max || '999', 10);
    const incr = wrap.querySelector('[data-qty-incr]');
    const decr = wrap.querySelector('[data-qty-decr]');
    const totalEl = document.querySelector(`[data-qty-total="${wrap.dataset.qty}"]`);
    const amountEl = totalEl ? totalEl.querySelector('[data-qty-amount]') : null;
    const piecesEl = wrap.querySelector('[data-qty-pieces]'); // adet ile fiyat arasında (müşteri isteği)
    const pack = parseInt(wrap.dataset.pack || '0', 10);

    const update = () => {
      const qty = Math.max(min, Math.min(max, parseInt(input.value || '1', 10) || min));
      input.value = qty;
      const unitPrice = parseFloat(wrap.dataset.unitPrice || '0'); // her seferinde oku — ölçü değişince güncellenir
      if (unitPrice) {
        const target = amountEl || totalEl;
        if (target) target.textContent = formatTRY(qty * unitPrice);
      }
      // müşteri isteği: paket × paket-içi = toplam koli adedi belirgin gösterilsin
      if (piecesEl && pack) piecesEl.textContent = `${qty} paket × ${pack} adet = ${qty * pack} koli`;
      if (decr) decr.disabled = qty <= min;
      if (incr) incr.disabled = qty >= max;
    };

    if (incr) incr.addEventListener('click', () => { input.value = parseInt(input.value || '1', 10) + 1; update(); });
    if (decr) decr.addEventListener('click', () => { input.value = parseInt(input.value || '1', 10) - 1; update(); });
    input.addEventListener('input', update);
    wrap.addEventListener('qty:refresh', update); // ölçü seçiminden tetiklenir
    update();
  });

  // ---- Product: ölçü combo box → fiyat/birim/kademe anında güncellenir (port'ta variant-selects) ----
  const olcuCombo = document.querySelector('[data-olcu-combo]');
  if (olcuCombo) {
    const fmt2 = (n) => n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const priceEl = document.querySelector('[data-price-amount]');
    const compareEl = document.querySelector('[data-price-compare]');
    const haricEl = document.querySelector('[data-price-haric]');
    const birimEl = document.querySelector('[data-price-birim]');
    const subtitleEl = document.querySelector('[data-olcu-current]');
    const qtyWrap = document.querySelector('[data-qty]');
    const tierUnits = Array.from(document.querySelectorAll('.qty-break__unit'));
    const kalitePrices = Array.from(document.querySelectorAll('.kalite-toggle__opt-price strong'));
    const TIERS = [1, 0.95, 0.9, 0.8];          // toptan kademeleri (qty-break tablosuyla aynı)
    const PREMIUM = 312 / 248;                   // premium kalite çarpanı (mevcut fiyat oranı)
    const PACK = qtyWrap ? parseInt(qtyWrap.dataset.pack || '20', 10) : 20;

    olcuCombo.addEventListener('change', () => {
      const opt = olcuCombo.selectedOptions[0];
      if (!opt) return;
      const price = parseFloat(opt.dataset.price || '0');
      if (!price) return;
      if (priceEl) priceEl.textContent = Math.round(price) + ' TL';
      if (compareEl && opt.dataset.compare) compareEl.textContent = Math.round(parseFloat(opt.dataset.compare)) + ' TL';
      if (haricEl) haricEl.textContent = fmt2(price / 1.2) + ' TL';
      if (birimEl) birimEl.textContent = fmt2(price / PACK) + ' TL';
      if (subtitleEl) subtitleEl.textContent = opt.dataset.olcu;
      tierUnits.forEach((el, i) => { if (TIERS[i] != null) el.textContent = Math.round(price * TIERS[i]) + ' TL'; });
      if (kalitePrices[0]) kalitePrices[0].textContent = Math.round(price) + ' TL';
      if (kalitePrices[1]) kalitePrices[1].textContent = Math.round(price * PREMIUM) + ' TL';
      if (qtyWrap) {
        qtyWrap.dataset.unitPrice = String(price);
        qtyWrap.dispatchEvent(new Event('qty:refresh'));
      }
    });
  }

  // ---- Hemen Öde (prototip placeholder — Shopify port'ta dynamic checkout) ----
  document.addEventListener('click', (e) => {
    const buy = e.target.closest('[data-buy-now]');
    if (!buy) return;
    e.preventDefault();
    buy.classList.add('is-busy');
    setTimeout(() => buy.classList.remove('is-busy'), 900);
  });

  // ---- Collection page: filter drawer (mobile) ----
  const drawer = document.querySelector('[data-filter-drawer]');
  const drawerOpenBtn = document.querySelector('[data-filter-open]');
  const drawerCloseBtn = document.querySelector('[data-filter-close]');
  const drawerOverlay = document.querySelector('[data-filter-overlay]');

  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    if (drawerOverlay) drawerOverlay.classList.toggle('is-visible', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };

  if (drawerOpenBtn) drawerOpenBtn.addEventListener('click', () => setDrawer(true));
  if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', () => setDrawer(false));
  if (drawerOverlay) drawerOverlay.addEventListener('click', () => setDrawer(false));

  // ---- Active filter chips: × removes the chip and unchecks underlying input ----
  document.addEventListener('click', (e) => {
    const removeIcon = e.target.closest('[data-chip-remove]');
    if (!removeIcon) return;
    const chip = removeIcon.closest('.active-filters__chip');
    const filterName = chip && chip.dataset.filterName;
    const filterValue = chip && chip.dataset.filterValue;
    if (filterName && filterValue) {
      document
        .querySelectorAll(
          `input[name="${filterName}"][value="${filterValue}"]`
        )
        .forEach((input) => {
          input.checked = false;
        });
    }
    chip && chip.remove();
  });

  // ---- File upload — show selected filename ----
  document.querySelectorAll('[data-file-upload]').forEach((wrap) => {
    const input = wrap.querySelector('input[type="file"]');
    const label = wrap.querySelector('[data-file-label]');
    if (!input || !label) return;
    const original = label.textContent;
    input.addEventListener('change', () => {
      const file = input.files && input.files[0];
      if (file) {
        label.textContent = file.name;
        wrap.classList.add('is-active');
      } else {
        label.textContent = original;
        wrap.classList.remove('is-active');
      }
    });
  });

  // ---- Quote form submit (placeholder — Shopify will replace) ----
  const quoteForm = document.querySelector('[data-quote-form]');
  if (quoteForm) {
    quoteForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const submit = quoteForm.querySelector('[type="submit"]');
      if (submit) {
        const original = submit.textContent;
        submit.disabled = true;
        submit.textContent = 'Gönderiliyor…';
        setTimeout(() => {
          submit.textContent = 'Teklif talebiniz alındı ✓';
          setTimeout(() => {
            submit.disabled = false;
            submit.textContent = original;
            quoteForm.reset();
          }, 2400);
        }, 800);
      }
    });
  }

  // ---- View toggle (grid/list) ----
  document.querySelectorAll('[data-view-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      document
        .querySelectorAll('[data-view-toggle]')
        .forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  // ---- Product gallery: thumbnail swap ----
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    const caption = gallery.querySelector('[data-gallery-caption]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        gallery
          .querySelectorAll('[data-gallery-thumb]')
          .forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const bg = thumb.dataset.bg;
        const cap = thumb.dataset.caption || '';
        if (main && bg) main.style.background = bg;
        if (caption) caption.textContent = cap;
      });
    });
  }

})();


/* ---- Çerez tercihleri: Shopify yerleşik çerez banner'ının tercih penceresini aç ----
   Banner (Settings → Customer privacy) kapalıysa link normal davranır ve gizlilik sayfasına gider. */
(function () {
  var links = document.querySelectorAll('[data-cookie-prefs]');
  if (!links.length) return;
  function openPrefs(e) {
    if (!(window.Shopify && typeof window.Shopify.loadFeatures === 'function')) return; // fallback: href
    e.preventDefault();
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') {
        window.location.href = e.currentTarget && e.currentTarget.href ? e.currentTarget.href : '/pages/gizlilik-politikasi#cerez-politikasi';
        return;
      }
      window.privacyBanner.showPreferences();
    });
  }
  links.forEach(function (a) { a.addEventListener('click', openPrefs); });
})();
